 
  angular.module('angus.controllers').component('riderDiscounts', {
    templateUrl: 'templates/tankMonitor/inventoryManagement/components/riderDiscounts/riderDiscountView.html',  
    bindings: {
        model: '='
    },
    controller: function RiderDiscountsController(_, riderDiscountService, moment, $rootScope, toastService) {
        var vm = this; 
   
        this.isLoading = false;    
        this.discountYearHasError = false;
        this.discountAmountHasError = false;
        this.months = [1,2,3,4,5,6,7,8,9,10,11,12];
        this.rowStatus = {
            active: 1,
            delete: 3
        }   

        this.yearEnteredHandler = function(value) {  
            vm.discountYearHasError = false;
            if (!moment(value, 'YYYY', true).isValid()) {
                vm.discountYearHasError = true; 
            }      
        }

        this.amountEnteredHandler = function(value) {  
            var discount = value.toString().replace('$', '');
            discount = parseFloat(discount);
            vm.discountAmountHasError = false;
            if (isNaN(discount)) { 
                vm.discountAmountHasError = true; 
            }      
        }

        this.submitHandler = function(form, rowStatusKey) { 
            var discount = vm.model.riderDiscount;
            discount.discountAmount = discount.discountAmount.toString().replace('$', '');
            const newDate = moment({ year: discount.discountYear, month: discount.discountMonth - 1});
            discount.discountDate = newDate;
            discount.updateUser = $rootScope.user.username;  
            discount.rowStatusKey = rowStatusKey;    
            vm.orderSubmitLoading = true;   
 
            var promiseResponse = null;
            if (discount.riderDiscountKey) {
                promiseResponse = riderDiscountService.updateRiderDiscount(discount.riderDiscountKey, discount);
            }
            else {            
                promiseResponse = riderDiscountService.createRiderDiscount(discount);
            }
            promiseResponse
            .then(function(result) {
                var riderDiscountKey = result.riderDiscountKey;
                if (riderDiscountKey > 0) {  
                    if (rowStatusKey == vm.rowStatus.active) {  
                        toastService.addToast(toastService.types.success, 'The discount has been saved successfully', 5000); 
                    }
                    else {  
                        toastService.addToast(toastService.types.success, 'The discount has been deleted successfully.', 5000); 
                        vm.model.deleteVM(vm.model.index);
                    } 
                }
                else {  
                    toastService.addToast(toastService.types.danger, 'Failed to Submit, Please check the data!', 5000); 
                }
            })
            .catch(function(error) {      
                toastService.addToast(toastService.types.error, 'Failed to Submit, Please check the data!', 5000); 
            });  

            vm.orderSubmitLoading = false; 
        }

        this.clickDeleteDiscount = function(form) {  
            if (vm.model && vm.model.riderDiscount.riderDiscountKey) {
                if(confirm("Are you sure to delete the discount?")) {
                    vm.submitHandler(form, vm.rowStatus.delete); 
                }
            }
            else {
                vm.model.deleteVM(vm.model.index);
                toastService.addToast(toastService.types.success, 'The discount has been deleted successfully.', 5000); 
            }  
        } 
    }
});